














































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { getElegantDateString, getTimeSince } from "@/utils/date-helpers";
import { formatPrice } from "@/utils/string-helpers";

/**
 * Components
 */
import DataFetcher from "@/components/_global/DataFetcher.vue";
import TeamContributionCard from "./components/TeamContributionCard.vue";

/**
 * API
 */
import usersAPI from "@/api/users";
import stripeAPI, { SetupResponse } from "@/api/stripe";
import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";
import { Guid } from "@/domain/guid";

/**
 * Types
 */

/**
 * VueX Modules
 */
const profileModule = namespace("profile");

/**
 * User premium page.
 */
@Component({
	components: {DataFetcher, TeamContributionCard},
})
export default class PremiumPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;

	formatPrice = formatPrice;

	getTimeSince = getTimeSince;
	getElegantDateString = getElegantDateString;

	/// Properties

	/// Attributes
	isLoading = false;
	stripeSetup: SetupResponse | null = null;
	teamsContributions: any[] | null = null;

	/// VueX Modules
	@profileModule.Action("fetchUserDetails")
	fetchUserDetails: any;

	@profileModule.State("userDetails")
	userDetails!: GetCurrentUserResponse;


	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchUserDetails();
		this.stripeSetup = await stripeAPI.getSetup();
		await this.refreshContributions();
	}

	async refreshContributions() {
		this.teamsContributions = await usersAPI.getMyTeamsContributions();
	}

	async handleCreateStripeSessionClick(priceId: string) {
		this.isLoading = true;
		try {
			const session = await stripeAPI.createCheckoutSession({priceId: priceId});
			if (this.stripeSetup != null) {
				const stripe = Stripe(this.stripeSetup.publishableKey);
				const result = await stripe
					.redirectToCheckout({
						sessionId: session.sessionId
					});
				if (result.error) {
					console.log(result.error.message);
				}
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleGoToStripeCustomerPortalClick(priceId: string | null = null) {
		this.isLoading = true;
		try {
			const session = await stripeAPI.createCustomerPortal({priceId: priceId});
			window.location.href = session.sessionUrl;
		} catch (error) {
			this.handleAPIError(error);
			this.isLoading = false;
		}
	}

	async handleRemoveBoostTeam(teamID: Guid) {
		this.isLoading = true;
		try {
			await usersAPI.removeContributionToTeam(teamID);

			await Promise.all([this.fetchUserDetails(), this.refreshContributions()]);
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleAddBoostTeam(teamID: Guid) {
		this.isLoading = true;
		try {
			await usersAPI.addContributionToTeam(teamID);
			await Promise.all([this.fetchUserDetails(), this.refreshContributions()]);
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
